import type { Partner } from 'src/graphql';
import { PartnerRaw } from 'src/types';
import { create } from 'zustand';

type PartnerState = {
  partners: Record<string, Partner> | null;
  partnersRaw: Map<number, PartnerRaw>;
  loading: boolean;
  setPartners: (
    partners: Record<string, Partner> | null,
    raw: Map<number, PartnerRaw>,
  ) => void;
  setLoading: (loading: boolean) => void;
  removePartners: () => void;
};

export const usePartnerStore = create<PartnerState>((set) => ({
  partners: null,
  partnersRaw: new Map(),
  loading: true,

  setPartners: (partners, partnersRaw) => set({ partners, partnersRaw, loading: false }),
  setLoading: (loading) => set({ loading }),
  removePartners: () => set({ partners: null, partnersRaw: new Map(), loading: false }),
}));
